import Vue from 'vue'
import App from './app.vue'

// Ant Design Vue
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import "@/assets/global.css"

// Vue Meta
import Meta from 'vue-meta'

// Vue Axios
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
})

Vue.use(VueAxios, http)

// Import the Auth0 configuration
import { domain, clientId, audience } from "../auth.config.json"

// Import the plugin here
import { Auth0Plugin } from "./auth"

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
})


Vue.config.productionTip = false

Vue.use(Antd)
Vue.use(Meta)

new Vue({
  router,
  created: () => {
    http.interceptors.request.use(async config => {
      const token = await Vue.prototype.$auth.getTokenSilently()
      config.headers.Authorization = `Bearer ${token}`
      return config
    }, error => Promise.reject(error))
  },
  render: h => h(App)
}).$mount('#app')
